<template>
  <div :class="getClassName">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

export default {};
</script>
